// assets/js/vendors.js

// jQuery + Bootstrap
import $ from 'jquery';
import * as bootstrap from 'bootstrap';

// Popper (falls direkt gebraucht – Bootstrap 5 holt sich ihn selbst, aber zur Sicherheit)
import '@popperjs/core';

// Flatpickr
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/de.js';

// Select2
import 'select2';
import 'select2/dist/css/select2.css';

// Tagify
import Tagify from '@yaireo/tagify';
import '@yaireo/tagify/dist/tagify.css';

// Quill
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

// Leaflet
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Leaflet Markercluster
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

// CropperJS
import Cropper from 'cropperjs';
import * as Vue from 'vue';

// 🔗 Globals setzen, damit dein Legacy-Code weiterhin funktioniert
window.$ = window.jQuery = $;
window.flatpickr = flatpickr;
window.Tagify = Tagify;
window.Quill = Quill;
window.L = L;
window.Cropper = Cropper;
window.Vue = Vue
window.bootstrap = bootstrap
